import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { StateService } from '@cosmos/angular/utils';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { FloatLabelModule } from 'primeng/floatlabel';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'cosmos-password-reset',
  imports: [TranslatePipe, FormsModule, RouterModule, MessageModule, ButtonModule, PasswordModule, FloatLabelModule, AuthLayoutComponent],
  templateUrl: './password-reset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ''
})
export class PasswordResetComponent implements OnInit {
    private stateService = inject(StateService);
    private router = inject(Router);
    private http = inject(HttpClient);
    private activatedRoute = inject(ActivatedRoute);

    password: string = '';
    confirmPassword: string = '';
    token: string;

    protected readonly loading = signal(false);
    protected readonly success = signal(false);
    protected readonly error = signal(false);

    constructor() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.token = params['token'];
        });
    }

    ngOnInit(): void {
        if (this.stateService.getCurrentUser()) {
            this.router.navigate(['/']);
        }
    }

    get passwordMismatch(): boolean {
        return !!this.confirmPassword && this.password !== this.confirmPassword;
    }

    onClick(){
        if (this.passwordMismatch) return;
        this.loading.set(true);
        this.success.set(false);
        this.error.set(false);

        this.http.post(`${environment.API_URL}/token/resetpassword/`, { token: this.token, password: this.password }, { observe: 'response' }).subscribe({
            next: () => {
                this.loading.set(false);
                this.success.set(true);
            },
            error: () => {
                this.loading.set(false);
                this.error.set(true);
            },
        });
    }
}
